import { PageHeader } from "@/components/app-layout";
import { Card, CardBody, CardHeader } from "@/components/ui/card";
import { Alert } from "@/components/ui/alert";

export function DashboardPage() {
    return (
        <>
            <PageHeader title="Tổng quan" description="Tình trạng tài khoản Zalo và các chiến dịch đang chạy" />

            <div className="space-y-4 p-8">
                <Alert tone="warning">
                    Zalo không có API chính thức cho tài khoản cá nhân. Gửi thử một nhóm trước, giữ hạn mức
                    thấp.
                </Alert>

                <Card>
                    <CardHeader title="Bắt đầu" description="Ba bước để gửi chiến dịch đầu tiên" />
                    <CardBody>
                        <ol className="list-inside list-decimal space-y-1.5 text-sm text-ink-muted">
                            <li>Thêm tài khoản Zalo bằng cách quét mã QR.</li>
                            <li>Đồng bộ nhóm rồi gom thành các nhóm gửi dùng lại được.</li>
                            <li>Soạn chiến dịch, chọn nhóm gửi, gửi ngay hoặc hẹn lịch.</li>
                        </ol>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}
